import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { catchError, of } from 'rxjs';
import { AuthHelperService } from 'src/app/services/auth-helper.service';
import { MessageWrapperService } from 'src/app/services/message-wrapper.service';
import { CustomerDetails, CustomerGenSvc } from 'src/app/services_autogenerated/generated_services';

@Component({
  selector: 'app-combine-customer',
  templateUrl: './combine-customer.component.html',
  styleUrl: './combine-customer.component.css',
  standalone: false
})
export class CombineCustomerComponent implements OnInit {
  @Output() closeEvent: EventEmitter<null> = new EventEmitter();
  targetCustomer?: CustomerDetails;
  sourceCustomer?: CustomerDetails;
  
  selectedContacts: number[] = [];

  canCombine = false;

  constructor(private customerService: CustomerGenSvc, private authService: AuthHelperService, private messageService: MessageWrapperService) { }

  ngOnInit(): void {
    this.canCombine = this.authService.getDecodedAccessToken().claimNames.includes('Combine Customers');
  }

  setTarget(customerId: number) {
    if (customerId) {
      this.customerService.getCustomerDetails(customerId).subscribe(res => {
        this.targetCustomer = res;
      });
    } else {
      this.targetCustomer = undefined;
    }
  }
  
  setSource(customerId: number) {
    if (customerId) {
      this.customerService.getCustomerDetails(customerId).subscribe(res => {
        this.sourceCustomer = res;
      })
    } else {
      this.sourceCustomer = undefined;
    }
  }

  combine() {
    if (this.targetCustomer?.id && this.sourceCustomer?.id) {
      this.customerService.combineCustomers(this.targetCustomer.id, this.sourceCustomer.id, new Date(), this.selectedContacts)
      .pipe(catchError((error) => {
        console.log(error);
        return of(null);
       }))
      .subscribe(() => {
        this.messageService.addSuccessMessage('Successfully combined customers.')
        this.closeEvent.emit(null);
      });
    } else {

    }
  }
}
